function t(e) {
  return e.composedPath()[0] || null;
}
export {
  t as getPreciseEventTarget
};
